export { default } from "./Flex.deprecated";
export type { FlexProps } from "./Flex.deprecated";
